module.exports = __webpack_public_path__ + "fonts/Simple-Line-Icons.eot";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Simple-Line-Icons.eot
// module id = 284
// module chunks = 0